/* eslint-disable no-param-reassign, arrow-body-style */
import axios from 'axios';
import Vue from 'vue';
import router from '../../router/index';

const SESSION_CLOSED_ERROR = 'Сеанс доступа завершен. В целях безопасности просим Вас повторить вход в систему.';
const REDIRECT_AFTER_LOGOUT = '/user/authenticate';

const state = {
  authToken: '',
  authError: '',
  userId: '',
  authTokenExp: 0,
  userData: null,
  userRoles: null,
};

const getters = {

  getAuthToken(st) {
    return st.authToken;
  },

  getUserId(st) {
    return st.userId;
  },

  getAuthError(st) {
    return st.authError;
  },

  isAuthenticated(st) {
    return st.authToken.length > 0;
  },

  getUserData(st) {
    return st.userData;
  },

  getUserRoles(st) {
    return st.userRoles;
  },

  isOrgAdmin(st) {
    return st.userRoles
      ? st.userRoles.findIndex(r => r.Role === 'ORG_ADMIN') > -1 : false;
  },

  getWhereOrgAdmin(st) {
    const role = Array.isArray(st.userRoles)
      ? st.userRoles.find(r => r.Role === 'ORG_ADMIN') : [];
    return role && role.Args ? role.Args : [];
  },

  isSysAdmin(st) {
    return st.userRoles
      ? st.userRoles.findIndex(r => r.Role === 'SYS_ADMIN') > -1 : false;
  },

};

const mutations = {

  authenticate(st, { authToken, tokenData }) {
    st.authToken = authToken;
    st.authError = '';
    st.authTokenExp = tokenData.exp;
    st.userId = tokenData.sub;
    localStorage.setItem('authToken', authToken);
  },

  clearAuthData(st) {
    st.authToken = '';
    st.authTokenExp = 0;
    st.userId = '';
    localStorage.removeItem('authToken');
  },

  setAuthError(st, authError) {
    st.authError = authError;
  },

  setUserId(st, userId) {
    st.userId = userId;
  },

  setUserData(st, userData) {
    st.userData = userData;
  },

  setUserRoles(st, userRoles) {
    st.userRoles = userRoles;
  },

};

const actions = {

  startLogoutTimer({ commit, dispatch }, exp) {
    const millisecondsUntilLogout = new Date(exp * 1000) - new Date();
    setTimeout(() => {
      commit('setAuthError', SESSION_CLOSED_ERROR);
      dispatch('logout');
    }, millisecondsUntilLogout);
  },

  mountAuthToken(ctx, authToken) {
    // Get token data
    const tokenData = JSON.parse(atob(authToken.split('.')[1]));

    const payload = {
      authToken,
      tokenData,
    };
    // Check token expired
    const millisecondsLeft = new Date(tokenData.exp * 1000) - new Date();
    if (millisecondsLeft <= 0) {
      ctx.commit('setAuthError', SESSION_CLOSED_ERROR);
      ctx.dispatch('logout');
    }

    // Accept token data
    ctx.commit('authenticate', payload);
    ctx.dispatch('fetchUserRoles', tokenData.sub);
    ctx.dispatch('fetchUserData', tokenData.sub);
    ctx.dispatch('startLogoutTimer', tokenData.exp);
  },

  tryAutoAuth({ dispatch }) {
    const authToken = localStorage.getItem('authToken');
    if (authToken) dispatch('mountAuthToken', authToken);
  },

  logout({ commit }) {
    commit('clearAuthData');
    router.replace(REDIRECT_AFTER_LOGOUT);
  },

  authenticate({ commit, dispatch }, { mail, password }) {
    if (mail && password) {
      Vue.$loading.on();
      axios.post('users/authenticate/token', { mail, password }).then((r) => {
        dispatch('mountAuthToken', r.data);
        Vue.$loading.off();
      }).catch((err) => {
        commit('setAuthError', err.response.data);
        Vue.$loading.off();
      });
    }
  },

  fetchUserData(ctx, userId) {
    axios.get(`users/${userId}`).then((r) => {
      ctx.commit('setUserData', r.data);
    });
  },

  fetchUserRoles(ctx, userId) {
    axios.get(`users/${userId}/roles`).then((r) => {
      ctx.commit('setUserRoles', r.data);
    });
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js